import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Row, Col, Spin, Icon } from 'antd';
import { fetchSampleTemplates } from '../actions/sessionActions';
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'Label Size',
    width: 10
  },
  {
    title: 'Recommended Courier Partner',
    width: 45
  },
  {
    title: 'File Upload',
    key: 'file_upload',
    width: 30
  },
  {
    title: 'Created At',
    width: 15
  }
];

export class SampleTemplates extends Component {
  constructor() {
    super();
    this.state = { enterpriseId: undefined, enterprise: null };
  }

  componentDidMount() {
    this.props.fetchSampleTemplates();
  }

  render() {
    const { sampleTemplates } = this.props;
    return (
      <div>
        <Row>
          <Col span={24} className="margin-bottom-10">
            {sampleTemplates.isFetching ? (
              <Spin indicator={antIcon} />
            ) : (
              <Fragment>
                {sampleTemplates.list.length <= 0 ? (
                  <div>&nbsp; No Data</div>
                ) : (
                  <Fragment>
                    <table className={`ant-table ant-table-small width-100pt`}>
                      <thead className="ant-table-thead">
                        <tr>
                          {columns.map((item, i) => (
                            <th
                              className="padding-8"
                              key={i}
                              width={`${item.width}%`}
                            >
                              {item.title}
                              {/* <Icon type="sort-ascending" /> */}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="ant-table-tbody">
                        {sampleTemplates.list.map((item, i) => (
                          <tr key={i}>
                            <td className="padding-8">{item.label_size}</td>
                            <td className="padding-8">{item.tags}</td>
                            <td className="padding-8">
                              <a
                                href={`https://pyck-res-bucket.s3.amazonaws.com/${item.file_upload}`}
                              >
                                {item.file_upload}
                              </a>
                            </td>
                            <td className="padding-8">{item.created_at}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Col>
          {/* {shippingLabels.count > shippingLabels.list.length &&
          shippingLabels.list.length > 0 ? (
            <Col span={24} className="text-center">
              <Button
                type="primary"
                onClick={this.pagination}
                loading={shippingLabels.isPaginationFetching}
                disabled={shippingLabels.isPaginationFetching}
              >
                Load More
              </Button>
            </Col>
          ) : null} */}
        </Row>
      </div>
    );
  }
}

SampleTemplates.propTypes = {
  sampleTemplates: PropTypes.object,
  metadata: PropTypes.object,
  config: PropTypes.object,
  match: PropTypes.object,
  fetchSampleTemplates: PropTypes.func
};

SampleTemplates.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  sampleTemplates: state.session.sampleTemplates,
  metadata: state.session.metadata
});

const mapDispatchToProps = dispatch => ({
  fetchSampleTemplates: () => dispatch(fetchSampleTemplates())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SampleTemplates)
);
